import React from 'react';
import imgSep from '../images/sep.png';

import { MdEmail,MdCall } from 'react-icons/md';

const Footer = () =>{
    return(    
        <>
        <div className='container-fluid' style={{padding:60,width:"100%",position:"relative",backgroundColor:"gainsboro",bottom:"0%"}}>
            <div className='row'>
                <div className='col' style={{textAlign:"center"}}>
                    <img alt="" src={imgSep} style={{width:250}}></img>

                </div>
                <div className='col' style={{textAlign:"center"}}>
                    <p style={{color:"black"}}>Centro de Estudios Tecnológicos industrial y de servicios 158</p>
                    <p style={{color:"black"}}>Santa Catarina, 30470 Villaflores, Chis.</p>
                </div>
                <div className='col' style={{textAlign:"center"}}>
                    <p style={{color:"black"}}><MdEmail/> 9656909335</p>
                    <p style={{color:"black"}}><MdCall/> cetis158@cetis.com</p>
                </div>

            </div>
        </div>
        </>
    )

}
export default Footer;